
import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../../api';
import { OTPCheckRequest } from './otpcheckrequest';

export class OTPCheckAPI extends APIImpl<OTPCheckRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/otp-check
        return "otp-check";
    }
    
    getRequestData()
    {
        return "msisdn=" + this.getRequest().getOTPCheckRequest().getMsisdn() +"&"+
               "language="+ this.getContext().getUserContext().getLanguage()+"&"+
               "clientTxnId=21052020&"+
               "otp="+ this.getRequest().getOTPCheckRequest().getOtp()+"&"+
               "secToc="+ this.getRequest().getOTPCheckRequest().getSecToc()+"&"+
               "type=ValidateDetails";
            //    "secToc="+ this.getRequest().getOTPCheckRequest().getSecToc()+"&"+
            //    "type="+ this.getRequest().getOTPCheckRequest().getType();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/otpcheck/otpcheckapi.tsx